export const ACCEPTABLE_DOCUMENTS = [
  'NameAndAddress',
  'NameAndDOB',
  'FinancialAccount',
] as const;
